const LoadingProgressBar = () => {
  return (
    <div className={'w-full overflow-hidden rounded-full bg-core-black-contrast h-[6px]'}>
      <div className="h-full bg-minima-orange-2023 animate-loading-bar rounded-full w-[40%] " />
    </div>
  );
};
export default LoadingProgressBar;
